import { render } from "./STLPreviewWindow.vue?vue&type=template&id=56191ade&scoped=true"
import script from "./STLPreviewWindow.vue?vue&type=script&lang=js"
export * from "./STLPreviewWindow.vue?vue&type=script&lang=js"

import "./STLPreviewWindow.vue?vue&type=style&index=0&id=56191ade&scoped=true&lang=css"

import exportComponent from "/builds/tumeda/flui3d-mold/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56191ade"]])

export default __exports__